import _ from 'lodash';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Breadcrumbs from 'modules/common/components/Breadcrumbs';

type JobType = {
  categories?: Array<string>;
  categoryTranslation?: Array<{ _id: string; title: string }>;
  id: string;
  title: string;
};
interface Props {
  jobType?: JobType;
  pro: {
    location: {
      city?: { key: string; name: string };
      prefecture?: { key: string; name: string };
    };
    name?: string;
    slug: string;
  };
}
/* Currently available only in Japanese */
const setCategoryTitle = (
  language: string,
  categorieTitle: string,
  categoryTranslation: Array<{ _id: string; title: string }>
) => {
  if (language !== 'ja') return categorieTitle;
  const translatedTitle = categoryTranslation.find((item) => item._id === categorieTitle)?.title;
  if (translatedTitle === undefined) return categorieTitle;
  return translatedTitle;
};

const getCategoryCrumbs = (language: string, jobType: JobType | undefined) => {
  if (jobType === undefined) return [];
  if (
    jobType.categories === undefined ||
    jobType.categories.length < 2 ||
    jobType.categoryTranslation === undefined
  )
    return [];
  const categoryCrumbs = [];
  let categoryLink = '';
  const targetJobCategories = [jobType.categories[0], jobType.categories[1]];
  for (const jobCategory of targetJobCategories) {
    categoryLink = categoryLink ? `${categoryLink}/${jobCategory}` : `${jobCategory}`;
    categoryCrumbs.push({
      link: `${language === 'en' ? '/en' : ''}/${categoryLink}`,
      text: setCategoryTitle(language, jobCategory, jobType.categoryTranslation),
    });
  }
  return categoryCrumbs;
};

export const getCrumbs = ({
  city,
  jobType,
  language,
  prefecture,
  proSlug,
  proName,
}: {
  city?: { key: string; name: string };
  jobType?: JobType;
  language: string;
  prefecture?: { key: string; name: string };
  proName: string;
  proSlug: string;
}) => {
  const linkPrefix =
    jobType?.categories &&
    `${language === 'en' ? '/en' : ''}/${jobType.categories.join('/')}/${jobType.id}`;

  const crumbs = [
    ...getCategoryCrumbs(language, jobType),
    jobType &&
      linkPrefix && {
        link: linkPrefix,
        text: jobType.title,
      },
    linkPrefix &&
      prefecture &&
      prefecture.name && {
        link: `${linkPrefix}/${prefecture.key}`,
        text: prefecture.name,
      },
    linkPrefix &&
      prefecture &&
      prefecture.name &&
      city &&
      city.name && {
        link: `${linkPrefix}/${prefecture.key}/${city.key}`,
        text: city.name.replace('　', ''),
      },
    {
      link: `${language === 'en' ? '/en' : ''}/profile/${proSlug}/pro`,
      text: proName,
    },
  ];

  return _.compact(crumbs);
};

const ProBreadcrumbs: FC<Props> = ({
  jobType,
  pro: {
    location: { city, prefecture },
    name,
    slug,
  },
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  const crumbs = getCrumbs({
    city,
    jobType,
    language,
    prefecture,
    proName: name ?? '',
    proSlug: slug,
  });

  return (
    <div className="wrapper">
      <Breadcrumbs align="left" crumbs={crumbs} />

      <style jsx>
        {`
          .wrapper {
            padding: 0.5rem 1rem;
          }

          @media screen and (min-width: 960px) {
            .wrapper {
              padding-left: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ProBreadcrumbs;
